export const SET_CARD_DATA = "SET_CARD_DATA";
export const RESET_CARD_DATA = "RESET_CARD_DATA";

export function setCardData(cardForm) {
  return {
    type: SET_CARD_DATA,
    cardForm
  };
}

export function resetCardData() {
  return {
    type: RESET_CARD_DATA
  };
}
